import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

const PAGE_SIZE = 10;

/**
 * Guías de remisión — colección REAL en el código vivo: `GR`
 * (GuiasRemision.js lee "GR"; GenerarGuia.js escribe en "GR").
 * El backup antiguo tiene `guia` casi vacío; no se usa.
 * NO se reimplementa SUNAT / MotorNumeracion aquí.
 */
export function mapGuide(snap) {
  return { id: snap.id, ...snap.data() };
}

export async function listGuides({ ruc, pageSize = PAGE_SIZE, search = '' }) {
  if (!ruc) throw new Error('RUC requerido');

  const constraints = [where('ruc', '==', ruc)];
  // orderBy puede fallar si el doc no tiene fechaEmision uniforme; usamos limit + sort local
  const snap = await getDocs(
    query(collection(db, 'GR'), ...constraints, limit(pageSize * 2))
  );

  let items = snap.docs.map(mapGuide);
  items.sort((a, b) => {
    const da = new Date(a.fechaEmision || a.createdAt || 0);
    const db = new Date(b.fechaEmision || b.createdAt || 0);
    return db - da;
  });

  if (search) {
    const term = search.trim().toLowerCase();
    items = items.filter((g) => {
      const serieNum = `${g.serie || ''}-${g.correlativo ?? ''}`.toLowerCase();
      const dest = String(
        g.destinatario?.rznSocial || g.destinatario?.numDoc || g.rznSocial || ''
      ).toLowerCase();
      return serieNum.includes(term) || dest.includes(term);
    });
  }

  return { items: items.slice(0, pageSize), hasMore: snap.docs.length >= pageSize * 2 };
}

export async function getGuide(id) {
  const snap = await getDoc(doc(db, 'GR', id));
  if (!snap.exists()) throw new Error('Guía no encontrada');
  return mapGuide(snap);
}

export async function listConductores({ ruc, pageSize = 10 }) {
  if (!ruc) throw new Error('RUC requerido');
  const snap = await getDocs(query(collection(db, 'conductores'), where('ruc', '==', ruc), limit(pageSize)));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function listVehiculos({ ruc, pageSize = 10 }) {
  if (!ruc) throw new Error('RUC requerido');
  const snap = await getDocs(query(collection(db, 'vehiculos'), where('ruc', '==', ruc), limit(pageSize)));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
